<template>
  <div class="p-30">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="handleLoadMore"
    >
      <div v-for="(v, i) in listData" :key="i" class="m-b-30 ticket_list_item">
        <div class="left_con bg-white p-lr-36 p-tb-34 f-cl h-block">
          <div>
            <span class="c-ft-32">{{ v.TicketName }}</span>
          </div>
          <div>
            <div class="m-b-10 c-ft-24" :style="{ color: '#999' }">
              <span>有效期: </span>
              <span>{{ v.UseStartDate }} 至 {{ v.UseEndDate }}</span>
            </div>
          </div>
          <div v-if="v.TicketStatus.Id == 1 && v.CanBeGift">
            <van-button
              round
              color="var(--tc)"
              size="mini"
              @click.stop="handleSendTicket(v)"
              >赠送给朋友</van-button
            >
          </div>
          <div class="circle"></div>
          <div class="circle2"></div>
        </div>
        <div class="right_con bg-white p-lr-36 p-tb-34 c-fc-center h-block">
          <div>
            <div class="money">
              <span>￥</span>
              <span>{{ v.Price }}</span>
            </div>
            <!-- <div class="sub-txt">{{ v.UseLimit || "" }}</div> -->
          </div>
          <div class="">
            <span>
              <van-button
                round
                color="var(--tc)"
                size="small"
                @click="handleShowUseCode(v)"
                :disabled="v.TicketStatus.Id !== 1"
                >{{
                  v.TicketStatus.Id == 1 ? "去使用" : v.TicketStatus.Name
                }}</van-button
              >
            </span>
          </div>
        </div>
      </div>
    </van-list>
    <!-- <van-dialog
      title="票券码"
      v-model="showQr"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
      <div class="p-26 c-fc-center">
        <div class="code_con">
          <vue-qr :text="qrCode" class="qr_code"></vue-qr>
        </div>
        <p>结账时请向收银员出示此码</p>
      </div>
    </van-dialog> -->
    <van-overlay :show="showQr" z-index="5">
      <div class="overlay_con">
        <div class="code_con">
          <p class="m-tb-20 code_title">票券码</p>
          <div class="codeImage" v-show="qrCode">
            <vue-qr :text="qrCode" class="qr_code"></vue-qr>
            <!-- <img :src="electronicImage" alt=""> -->
          </div>
          <div>{{ qrCode }}</div>
          <p class="m-t-20 m-b-60 c-lightgrey">结账时向收银员出示此码</p>
          <!-- <p class="c-orange code_tip">生成一次性支付码给好友</p> -->
          <van-icon
            name="close"
            class="close_btn_con"
            color="#fff"
            size="30"
            @click="hideModel"
          />
        </div>
      </div>
    </van-overlay>
    <shareOverlay
      ref="shareOverlayRef"
      @handleGetList="handleGetList"
    ></shareOverlay>
  </div>
</template>

<script>
// import {receiveCoupon} from '@/api/coupon'
import { getUserCouponList, transferMyTicket } from "@/api/coupon";
import { Toast } from "vant";
import wxConfig from "@/utils/wxConfig.js";
import shareOverlay from "@/components/shareOverlay/index.vue";
export default {
  name: "CouponsListCom",
  // props: {
  //   listData: {
  //     type: Array,
  //     default: () => {
  //       return [];
  //     },
  //   },
  // },
  components: { shareOverlay },

  data() {
    return {
      listData: [],
      nowPageIndex: 0,
      allPage: 0,
      loading: false,
      finished: false,
      showQr: false,
      qrCode: "",
    };
  },

  mounted() {},
  methods: {
    handleInitGetTicketList() {
      this.nowPageIndex = 0;
      this.handleGetTicketCoupon();
    },
    // 获取票券列表
    handleGetTicketCoupon(flag) {
      // let params = {
      //   Query: {
      //     WechatOrderStatus: 'Consuming'
      //   },
      //   Pager: {
      //     pageSize: 100,
      //     pageIndex: 0
      //   }
      // }
      // this.$http('apiorder/consuminglist', params, 'post').then(res => {
      //   this.tableList[1].label = `${res.Pager.TotalAmount2}张 票券可用`
      getUserCouponList({
        query: { IsCoupon: false, Status: 1, VpnId: this.$store.state.vpnId },
        pager: { pageindex: this.nowPageIndex, pagesize: 20 },
      })
        .then((res) => {
          res.Items.forEach((v) => {
            v.UseEndDate = v.UseEndDate.split(" ")[0];
            v.UseStartDate = v.UseStartDate.split(" ")[0];
          });

          this.listData =
            flag == "loadmore" ? this.listData.concat(res.Items) : res.Items;
          this.allPage = res.Pager.TotalPage;
          const allCount = res.Pager.TotalCount;
          //   // 加载状态结束
          this.loading = false;
          if (flag !== "loadmore") {
            this.$emit("setTicketCount", allCount);
          }

          //   // 数据全部加载完成
          if (this.listData.length >= allCount) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    handleLoadMore() {
      if (this.nowPageIndex + 1 < this.allPage) {
        this.nowPageIndex++;
        this.handleGetDiscountCoupon("loadmore");
      }
    },
    handleShowUseCode(v) {
      // let id = v.TicketCode
      // this.$http(`discountticket/qrcode?code=${id}`).then(res => {
      // this.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      this.qrCode = v.TicketCode;
      this.showQr = true;
      // })
    },

    hideModel() {
      this.showQr = false;
    },
    handleSendTicket(item) {
      let that = this;
      this.$refs.shareOverlayRef.handleSetShowShare();
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      const imgData = item.Claims.find((imgItem) => imgItem.TypeId == 0);
      transferMyTicket({ TicketCode: item.TicketCode }).then((res) => {
        const sendId = res;
        wxConfig.WeChatShare(
          this,
          window.location.href.split("#/")[0] +
            "#/ReceiveGiftCoupon/" +
            item.Id +
            "/" +
            sendId,
          "送你一张优惠券",
          imgData ? imgData.Value : "",
          "[" + item.TicketName + "]"
        );
      });
    },
    handleGetList() {
      this.handleInitGetTicketList();
    },
  },
};
</script>
<style scoped lang="scss">
.ticket_list_item {
  display: flex;
  overflow: hidden;
  box-sizing: border-box;
  &:last-child {
    margin-bottom: 0 !important;
  }
}
.left_con {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 150px;
  position: relative;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-right: 4px dashed #f7f7f7;

  .circle {
    position: absolute;
    right: -16px;
    top: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }
  .circle2 {
    position: absolute;
    right: -16px;
    bottom: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }
}
.right_con {
  // border-top-left-radius: 10px;
  // border-bottom-left-radius: 10px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  height: 216px;
  width: 200px;

  box-sizing: border-box;
  // background: url("../../assets/images/coupon-bg.png") no-repeat;
  // background-size: cover;
  justify-content: space-between;

  .sub-txt {
    font-size: 21px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #c7beb2;
    text-align: center;
  }
  .money {
    color: #c8465c;
  }
}
.code_con {
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 26px;
  width: 80vw;
  position: relative;

  .code_title {
    font-size: 30px;
  }
  .qr_code {
    width: 500px;
  }
  .close_btn_con {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
